import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AccountOptionsPage } from './account-options';

@NgModule({
  declarations: [
    AccountOptionsPage,
  ],
  imports: [
    IonicPageModule.forChild(AccountOptionsPage),
  ],
})
export class AccountOptionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/account-options/account-options.module.ts